import { GEOSchema } from "../_components/GEOSchema";

const productSchema = {
  "@id": "https://wiserstudio.ai/pricing/#product",
  name: "WiserStudio",
  description:
    "AI-Powered Autonomous Marketing Team — replace your marketing agency with AI agents.",
  brand: { "@type": "Brand", name: "WiserStudio" },
  offers: [
    {
      "@type": "Offer",
      name: "Starter",
      price: "49.00",
      priceCurrency: "USD",
      description:
        "1,500 credits/month, 2 concurrent agents, 3 brands, 720p video, basic AI models",
      availability: "https://schema.org/InStock",
      url: "https://wiserstudio.ai/pricing",
    },
    {
      "@type": "Offer",
      name: "Professional",
      price: "149.00",
      priceCurrency: "USD",
      description:
        "5,000 credits/month, 10 concurrent agents, 15 brands, 1080p video, all AI models, priority pipelines",
      availability: "https://schema.org/InStock",
      url: "https://wiserstudio.ai/pricing",
    },
    {
      "@type": "Offer",
      name: "Enterprise",
      price: "399.00",
      priceCurrency: "USD",
      description:
        "15,000 credits/month, unlimited agents, unlimited brands, 4K video, priority routing, dedicated support",
      availability: "https://schema.org/InStock",
      url: "https://wiserstudio.ai/pricing",
    },
  ],
};

const pricingFaqData = {
  "@id": "https://wiserstudio.ai/pricing/#faq",
  mainEntity: [
    {
      "@type": "Question",
      name: "Is there a free trial for WiserStudio?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. Every new account starts with a 14-day reverse trial on the Professional plan. No credit card required. You get full access to 5,000 credits, 10 concurrent agents, all AI models, and 1080p video for 14 days.",
      },
    },
    {
      "@type": "Question",
      name: "How much does WiserStudio cost?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "WiserStudio offers three plans: Starter at $49/month (1,500 credits, 2 agents), Professional at $149/month (5,000 credits, 10 agents), and Enterprise at $399/month (15,000 credits, unlimited agents). Annual billing saves 20%. Credit top-ups are available from $39 for 1,000 credits.",
      },
    },
  ],
};

export default function PricingLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <GEOSchema type="Product" data={productSchema} />
      <GEOSchema type="FAQPage" data={pricingFaqData} />
      {children}
    </>
  );
}
